import { IncentivePartner } from 'modules/shared/models/list/incentive-partner';
import { CMSImageContainerField, CMSContainerField } from 'modules/shared-cms/cms-base-type';
import { DenominatorTypeValues, EventType, HasOrganiserType, LightStore, ListType, Offer } from 'modules/shared/models';

export class ListIdentification {
    name: string = '';

    eventTypeId: string = '';

    listType: ListType = 0;

    denominatorType: number = 0;

    offerId: string = '';

    offerChoiceId: string = '';

    incentivePartnerId: string = '';

    date?: Date = undefined;

    storeId: string = '';

    referrer: string = '';

    code: string = '';

    password: string = '';

    passwordConfirm: string = '';

    constructor(listName?: string, listType?: string | number) {
        this.name = listName || '';
        // si on a choisi une liste pour un proche (url = ?listType=1)
        // on force le denominatorType à Orga / beneficiaire
        if (listType === 1)
            this.denominatorType = DenominatorTypeValues.RECIPIENT;
    }
}

export interface IdentificationFormOwnProps {
    picture: CMSContainerField<CMSImageContainerField[]>;
    model: ListIdentification;
    onSuccess: (model: ListIdentification) => void;
    onIncentiveExist: (code: string, eventId: string, storeId: string) => Promise<IncentivePartner>;
}

export interface IdentificationFormInjectedProps {
    eventTypes: EventType[];
    hasOrganiser?: HasOrganiserType;
    stores: LightStore[];
    offer: Offer;
}

export type IdentificationFormProps = IdentificationFormOwnProps & IdentificationFormInjectedProps;
